import About from "./components/about/about";
import React from "react";

import "./App.css";
import Footer from "./components/footer/footer";
import "./vendors/bootstrap-5.3.3/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Gallery from "./components/gallery/gallery";
import Home from "./components/home/home";
import Contact from "./components/contact/contact";
import Blogs from "./components/blogs/blogs";
import Blog from "./components/blogs/blog";
import NotFound from "components/notfound/notFound";

export const API_URL = process.env.REACT_APP_API_URL;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/">
            <Route index element={<Home />} />
          </Route>
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
          <Route path="gallery" element={<Gallery />} />
          {/* page with all blog posts, with first paragraph as blurb (replace home element) */}
          <Route path="blog" element={<Blogs />} />
          {/* page with individual blog post, fetch blog by blogID param (replace home element) */}
          <Route path="blog/:blogID" element={<Blog />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
